import SprintMetrics from './SprintMetrics';

export default SprintMetrics;
